import { render, staticRenderFns } from "./CourseProductItemForm.vue?vue&type=template&id=35e5b74c"
import script from "./CourseProductItemForm.vue?vue&type=script&lang=js"
export * from "./CourseProductItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports